import { localPersistance, cookiePersistance, tokenPersistance } from '@wallbox/http'
import state from '@/state'
import AuthActions from '@/utilities/authActions'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import ROUTES from '../routes'
import ENV from '@/engine/env/web.env'
import { provideAuthUseCases } from '@/core/auth'

export default function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  const valuesAuthActions = Object.values(AuthActions)
  const authAction = valuesAuthActions.find(value => value.action === to.query.action)?.hasToLogout

  const hasToLogout = to.query.forgot ?? authAction
  const persistance = ENV.api.authSystem === 'cookie' ? cookiePersistance : localPersistance

  if (hasToLogout) {
    void provideAuthUseCases().doLogout()
    tokenPersistance(persistance).remove()
    state.global.removeLocalStorageSensitiveInfo()
    state.user.setInitialState()
  }

  const token = tokenPersistance(persistance).getToken()

  if (requiresAuth && !token) {
    next({ name: ROUTES.AUTH_LOGIN, query: to.query })
  } else if (token && to.name === ROUTES.AUTH_LOGIN) {
    next({ name: ROUTES.CHARGERS, query: to.query })
  } else {
    next()
  }
}
